import { t, Trans } from '@lingui/macro';
import classnames from 'classnames';
import React, { FC } from 'react';

import './PwfSupportedBadge.scss';

type Props = {
  className?: string;
};

const PwfSupportedBadge: FC<Props> = (props) => {
  const hostCN = classnames('pwfSupportedBadge', props.className);

  return (
    <div className={hostCN} title={t`Dostępne Płatności Fixly`}>
      <span className="visually-hidden">
        <Trans>Dostępne Płatności Fixly</Trans>
      </span>
    </div>
  );
};

export default PwfSupportedBadge;
